import { render, staticRenderFns } from "./discovery.vue?vue&type=template&id=11185ad3&"
import script from "./discovery.vue?vue&type=script&lang=ts&"
export * from "./discovery.vue?vue&type=script&lang=ts&"
import style0 from "./discovery.vue?vue&type=style&index=0&id=11185ad3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports